import { types, SnapshotOut, Instance } from "mobx-state-tree";

export const PassingModel = types.model({
  id: types.identifier,
  mark: types.maybeNull(types.number),
  maxMark: types.maybeNull(types.number),
  successful: types.maybeNull(types.boolean),
  passingPercent: types.maybeNull(types.number),
  passingTestPercent: types.maybeNull(types.number),
});

type PassingModelType = Instance<typeof PassingModel>;
export type PassingModel = PassingModelType;
type PassingModelTypeSnapshotType = SnapshotOut<typeof PassingModel>;
export type PassingModelSnapshot = PassingModelTypeSnapshotType;
